import { isValidPhoneNumber, parsePhoneNumber } from "react-phone-number-input";

export const REQUIRED_FIELDS_ERROR =
  "Prašau užpildyti visus privalomus laukelius";

export const isValidEmail = (email: string): boolean => {
  	return /\S+@\S+\.\S+/.test(email);
};

export const isPasswordValid = (password: string): boolean => {
  	return /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/.test(password);
};
// /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,16}$/

/**
 * Validates a phone number.
 * If countryCode is provided, also checks the number belongs to that country.
 */
export const isPhoneValid = (phone: string, countryCode?: string): boolean => {
  if (!phone) return false;
  if (!isValidPhoneNumber(phone)) return false;
  if (countryCode) {
    try {
      const parsed = parsePhoneNumber(phone);
      return parsed?.country === countryCode.toUpperCase();
    } catch {
      return false;
    }
  }
  return true;
};
